import { render, staticRenderFns } from "./LeadReports.vue?vue&type=template&id=6fdb68d6&"
import script from "./LeadReports.vue?vue&type=script&lang=js&"
export * from "./LeadReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports